import { useEffect, useMemo } from 'react';
import { usePublicSettings } from '../Context/PublicSettingsContext';
import { useStorefront } from '../Context/StoreContext';

/** Title shipped in index.html — restored if the store has no business name. */
const FALLBACK_TITLE = '';

/**
 * Puts the merchant's business name in the browser tab.
 * Falls back to the organization name, then the store name.
 */
export function useStoreTitle() {
    const { publicSettings } = usePublicSettings();
    const { organization, store } = useStorefront();

    const title = useMemo(() => {
        const candidates = [publicSettings?.businessName, organization?.name, store?.name];
        const resolved = candidates.map((value) => String(value || '').trim()).find(Boolean);
        // Every store is seeded with this placeholder, retail included — not a real name.
        if (!resolved || resolved === 'Restaurant Name') return '';
        return resolved;
    }, [publicSettings?.businessName, organization?.name, store?.name]);

    useEffect(() => {
        if (!title) return undefined;

        const previousTitle = document.title;
        document.title = title;

        return () => {
            document.title = previousTitle || FALLBACK_TITLE;
        };
    }, [title]);
}

export default useStoreTitle;
